import { useEffect } from 'react';
import { api } from '@/lib/axios';
import { setSystemConfig } from '@/lib/systemConfig';

/** Loads l_system_config at admin boot and persists to localStorage for synchronous access. */
export function SystemConfigBootstrap() {
  useEffect(() => {
    api
      .get<{ key: string; value: string | null }[]>('/SystemConfig')
      .then(r => setSystemConfig(r.data))
      .catch(() => { /* non-fatal — system config just won't be available */ });
  }, []);

  return null;
}
